import { AVATAR_SIZES } from './constants';
const safelyParse = name => {
  try {
    const unicodeInitialsRegex = new RegExp(/(?:^|\s|-)+([^\s-])[^\s-]*(?:(?:\s+)(?:the\s+)?(?:jr|sr|II|2nd|III|3rd|IV|4th|\(.*\))\.?$)?/gi);
    const initials = name.replace(unicodeInitialsRegex, '$1').toUpperCase().trim();
    if (initials.length > 1) {
      return [initials.charAt(0), initials.charAt(initials.length - 1)];
    } else {
      return [initials.charAt(0)];
    }
  } catch (e) {
    var _name$match;
    // This regex gets initials for the english alphabet and is supported in all browsers.
    // We will fallback to this when the user is on an outdated browser version.
    const englishAlphabetNames = new RegExp(/\b\w/g);
    return (_name$match = name.match(englishAlphabetNames)) !== null && _name$match !== void 0 ? _name$match : [name.trimStart().charAt(0)];
  }
};
export default function initialsFromName(name, size) {
  var _initials$shift2, _initials$pop;
  if (!name) return null;
  const initials = safelyParse(name);
  if ((initials === null || initials === void 0 ? void 0 : initials.length) === 0) return null;

  // SMALL_16 has only one letter
  if (size === AVATAR_SIZES.SMALL_16) {
    var _initials$shift;
    return ((_initials$shift = initials.shift()) !== null && _initials$shift !== void 0 ? _initials$shift : '').toUpperCase();
  }
  return (((_initials$shift2 = initials.shift()) !== null && _initials$shift2 !== void 0 ? _initials$shift2 : '') + ((_initials$pop = initials.pop()) !== null && _initials$pop !== void 0 ? _initials$pop : '')).toUpperCase();
}
//# sourceMappingURL=initialsFromName.js.map